import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';

export class GlobalMessage extends LightLitElement {
    static get properties() {
        return {
            // The type of global message
            type: {
                type: String,
            },
            // If the message must be bold
            bold: {
                type: Boolean,
            },
        };
    }

    constructor() {
        super();

        this.type = '';
        this.bold = false;
    }

    firstUpdated() {
        window.scrollTo(0, 0);
    }

    render() {
        return html`
            <e2-message type="${this.type}" bold="${this.bold}">
                <div v-slot="message">
                    <v-slot name="message"></v-slot>
                </div>
            </e2-message>
        `;
    }
}

export class ConnectedGlobalMessage extends LightLitElement {
    render() {
        return html`
            <e2-connected-message
                store-name="global"
                field-name="globalMessages"
            ></e2-connected-message>
        `;
    }
}

export default () => {
    customElements.define('e2-global-message', GlobalMessage);
    customElements.define('e2-connected-global-message', ConnectedGlobalMessage);
};
